<div class="fc-accordion-item-header"
    role="button"
    [attr.id]="'accordion-header-' + id"
    [attr.aria-expanded]="expanded"
    [attr.aria-controls]="'accordion-body-' + id"
    [class.disabled]="disabled"
    [class.expanded]="expanded"
    (click)="toggleItem(id);">
    <span class="title">{{name}}</span>
    <span class="accordion-icon"></span>
</div>
<div class="fc-accordion-item-body"
    [attr.id]="'accordion-body-' + id"
    [style.display]="expanded ? '' : 'none'">
    <ng-content></ng-content>
</div>